<template>
  <div class="wheel">
    <div class="wheel-element-container">
      <div class="wheel-element" :style="`transform: rotate(${rotation}deg);`"></div>
      <div class="cap"></div>
    </div>
    <div class="pointer"></div>

    <div class="spin-button-container">
      <div :class="['spin-btn', spinning ? 'hide': '']" @click="spin">Spin the Wheel</div>
    </div>
    <div :class="['spin-count', spinning ? 'hide': '']">Spin: {{ spinCount}}</div>
  </div>
</template>

<script>
// @ is an alias to /src
// import IntroTile from "@/components/IntroTile/IntroTile.vue";

export default {
  name: "wheel",
  components: {
    // IntroTile
  },
  data() {
    return {
      rotation: 0,
      elementIndex: 0,
      element: this.$store.state.elements[0],
      elementList: [0, 1, 2, 3, 4, 5, 6, 7],
      spinning: false,
      extraSpin: 4 * 360,
      spinCount: 1
    };
  },
  computed: {},
  methods: {
    spin() {
      if (this.elementList.length < 1 || this.spinning) return;
      this.spinning = true;
      this.elementIndex = this.elementList.pop();
      this.element = this.$store.state.elements[this.elementIndex];
      let angle = this.getRandomInt(
        this.element.angle - 10,
        this.element.angle + 10
      );
      console.log("Setting angle:", angle);
      this.rotation = this.extraSpin - angle;
      setTimeout(this.showQuestion, 6000);
    },
    showQuestion() {
      this.$emit("showQuestion", this.element, this.elementList.length < 1);
      setTimeout(() => {
        this.rotation = 360 - (this.extraSpin - this.rotation); //0;
        this.spinning = false;
        this.spinCount += 1;
      }, 1000);
    },
    getRandomInt(min, max) {
      let minVal = Math.ceil(min);
      let maxVal = Math.floor(max);
      return Math.floor(Math.random() * (maxVal - minVal + 1)) + minVal;
    },
    shuffle(array) {
      return array.sort(() => Math.random() - 0.5);
    }
  },
  mounted() {
    this.elementList = this.shuffle(this.elementList);
  },
  beforeDestroy() {}
};
</script>

<style lang="scss" scoped>
.wheel {
  width: 80%;
  max-width: 810px;
  height: 70%;
  max-height: 600px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: visible !important;
}
.pointer {
  width: 100%;
  height: 15%;
  background-image: url("~@/assets/img/spinner.svg?external");
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: center bottom;
  position: absolute;
  top: -9%;
  left: 0;
  z-index: 5;
}

.wheel-element-container {
  position: relative;
  width: 100%;
  height: 80%;
  box-sizing: border-box;
  overflow: hidden !important;
}
.wheel-element {
  width: 100%;
  height: 100%;
  position: absolute;
  // margin-top: 10%;
  top: 0%;
  left: 0;
  background-image: url("~@/assets/img/wheel.svg?external");
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: center center;
  transform: rotate(0deg);
  transition: transform 5s; //+ optional path i.e. linear
  box-sizing: border-box;
  overflow: hidden !important;
}

.cap {
  width: 100%;
  height: 100%;
  position: absolute;
  // margin-top: 10%;
  top: 0%;
  left: 0;
  background-image: url("~@/assets/img/cap.svg?external");
  background-size: auto 40%;
  background-repeat: no-repeat;
  background-position: center center;
  transform: rotate(0deg);
  transition: transform 5s; //+ optional path i.e. linear
  box-sizing: border-box;
  overflow: hidden !important;
}

.spin-button-container {
  width: 100%;
  height: 20%;
  position: relative;
  // bottom: 0;
  // left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spin-btn {
  width: 80%;
  max-width: 235px;
  margin: 0 auto;
  height: 40px;
  background-color: rgba(0, 176, 240, 1);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-family: "VW Text";
  font-weight: normal;
  cursor: pointer;
  opacity: 1;
  transition: opacity 0.4s ease;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .spin-btn {
    margin: 0;
  }
}
.spin-count {
  font-family: "VW Text";
  font-weight: bold;
  font-size: 1.2rem;
  opacity: 1;
  transition: opacity 0.4s ease;
}

.hide {
  opacity: 0;
}
.spin-btn:hover {
  background-color: rgba(0, 176, 240, 0.8);
}

.spin-btn:active {
  background-color: rgba(0, 176, 240, 0.5);
}
</style>


<style lang="scss" scoped>
@media (max-width: 500px) {
  .wheel {
    width: 100%;
    height: 55%;
  }
}
</style>